import React, { Component } from 'react';
import { object } from 'prop-types';

class Banner extends Component {
  render () {
    let mobileAdjustHeight;
    if (this.props.style) {
      mobileAdjustHeight = 'adjust';
    }

    return (
      <div id='banner' style={this.props.styles} className={mobileAdjustHeight}>
        <div className='content'>
          <h1>{this.props.heading}</h1>
          <h3>{this.props.subHead}</h3>
          {this.props.children}
        </div>
      </div>
    );
  }
}

Banner.propTypes = { // validate props expected
  'styles': object,
  'style': object,
  'children': object.isRequired
};

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner/Banner.jsx